import React from 'react';
import cx from 'classnames';
import './SubmitButton.css';

export const SubmitButton = ({ text, classNames, ...props }) => {
    return <button {...props} className={cx(classNames, 'button')} >{text}</button>
};


// WEBPACK FOOTER //
// ./src/components/SubmitButton.js